import { Brands, Footer, Header, NavBar, Previews } from '../../components';

const Home = () => {
  return (
    <div className='landing-page'>
        {/*Universal skeleton layout for the entire webpage*/}
        <NavBar />
        <Header />
        <Previews />
        {/* <Brands /> */}
        <Footer />
    </div>
  )
}

export default Home